import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonRouteComponent } from "./sidebar-button-route.component";
import { gameTypeToGameInfo } from "@ponder-shared/utils/gameInfo";
import { GameType } from "@apiserver-rest/ponder-data-client-base";
import { getFromLocalStorage, LocalStorageKey } from "@ponder-shared/utils/localStorage";

@Component({
    selector: "sidebar-collection",
    imports: [],
    templateUrl: "./sidebar-button-route.component.html"
})
export class SidebarCollectionButtonComponent extends SidebarButtonRouteComponent {
    public constructor() { 
        var path = "collection";
        var selectedGame = getFromLocalStorage(LocalStorageKey.ActiveGameSelection, "all");

        if (selectedGame != "all") {
            path += "/" + gameTypeToGameInfo(selectedGame as GameType)?.uriName;
        }

        super("Collection", SvgIcon.Collection, path, false); 
    }
}